import auth from './Authentication/reducers';
import site from '@resources/Site/reducers';
import organizations, {
	organization,
} from '@common/resources/Organization/reducers';

export const reducers = { auth, organizations, organization, site };
